// extracted by mini-css-extract-plugin
export var content = "HeroLayout-module__content___k03U3";
export var hero = "HeroLayout-module__hero___ZdWL_";
export var img = "HeroLayout-module__img___blvaN";
export var picture = "HeroLayout-module__picture___iSNaB";